import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  deploy(e) {
    var clickedRow = $(e.target).closest(".row-container")[0]
    var clickedTitle = $(e.target).closest(".row-title")[0]

    $(".row-container").not(clickedRow).find(".row-detail").slideUp(200)
    $(".row-container").not(clickedRow).removeClass("active")

    $(clickedRow).find(".row-detail").slideToggle(200)
    $(clickedRow).toggleClass("active")

    // Update the URL to include the reference of the active tab
    if (clickedTitle.id && clickedRow.classList.contains("active")) {
      history.replaceState(null, null, `${window.location.pathname}?tab=${clickedTitle.id}`)
    } else {
      history.replaceState(null, null, `${window.location.pathname}`)
    }
  }
}
